import styled from 'styled-components'

import theme from '@/src/config/theme'

import {Link, linkColors} from '@/src/shared/ui/link'

export const Wrapper = styled.div<{$opened: boolean}>`
  z-index: 3000;

  padding: ${theme.token.layout.pagePadding * 2}px;

  position: fixed;
  top: ${theme.token.layout.headerHeight}px;
  height: calc(100vh - ${theme.token.layout.headerHeight}px);
  overflow-y: auto;

  display: ${props => (props.$opened && 'flex') || 'none'};
  flex-direction: column;

  background: ${theme.colors.white};
  color: ${theme.colors.textDark};

  left: 0;
  width: 100%;
`

export const NavLinks = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;

  ul {
    display: flex;
    flex-direction: column;

    gap: 6px;
  }
`

export const NavListItem = styled.div`
  width: 100%;

  :hover,
  :active {
    background: ${theme.colors.primary};
  }
`

export const NavLink = styled(Link)<{
  $dashed?: boolean
  ref?: unknown
}>`
  width: 100%;

  font-weight: 400;
  font-size: 1.0625rem;
  padding: 12px 6px;
  border-radius: 5px;

  ${props => linkColors({props, darkColor: theme.colors.white, darkHoverColor: theme.colors.dark})}

  &:hover {
    color: black;
  }
`
